import { NCows } from 'Input/NCows';
import { MilkYield } from 'Input/MilkYield';
import { DigestEnergy } from 'Input/DigestEnergy';
import { Typography, Stack } from '@mui/material';

const Numbers = () => {
    return (<Stack spacing={1}>
      
        <Typography variant='body1' component='h1' textAlign='center'>
  These inputs help estimate how much manure your farm generates.
  If you're unsure, leave Digestible Energy set to 0.7.
        </Typography>
  
     <>
      <NCows/>  
      <MilkYield/> 
      <DigestEnergy/> 
    </>
    </Stack>);

}

export default Numbers;
